import React from "react";
import classNames from "classnames";
import BusComponent from "../BusComponent";
import { injectIntl } from "react-intl";
import Tooltip from "../Tooltip";
import ConfirmationPopup from "./ConfirmationPopup";
import { getSavedLayers, isDefaultMap, resetMap } from "../../helpers/mapDefaults";
import Mixpanel, { MIXPANEL_EVENTS } from "../../helpers/Mixpanel";

class MapLayersPanelHeader extends BusComponent {
    constructor(props, context) {
        super(props, context)
    }

    onResetMapConfirm = () => {
        Mixpanel.emitUserEvent(MIXPANEL_EVENTS.RESET_MAP_DEFAULTS, { viewCode: this.context.viewCode });
        resetMap(this.bus);
    };

    onResetMapClick = () => {
        const onCurrentProject = ({ project, target }) => {
            if (target !== this) return;
            this.bus.off('CURRENT_PROJECT', onCurrentProject);
            this.openResetConfirmation(project);
        };
        this.bus.on('CURRENT_PROJECT', onCurrentProject);
        this.emit('CURRENT_PROJECT_REQUEST', { source: this });
    };

    openResetConfirmation(project) {
        const { intl } = this.props;
        const defaultMap = isDefaultMap();
        const title = (project && project.title) || intl.formatMessage({ id: 'untitledProject' });
        const layers = getSavedLayers();
        this.emit('OPEN_MODAL', {
            modalContent: (
                <ConfirmationPopup
                    confirmLabel={this.props.intl.formatMessage({ id: 'dataBrowser.resetMap' })}
                    onConfirm={this.onResetMapConfirm}
                    info={
                        <div>
                            <div>
                                {intl.formatMessage({ id: 'dataBrowser.resetMapTo' })}{' '}
                                <strong>
                                    {defaultMap
                                        ? intl.formatMessage({ id: 'dataBrowser.resetMapToDefault' })
                                        : intl.formatMessage({ id: 'dataBrowser.resetMapToSaved' }, { title })}
                                </strong>
                            </div>
                            <div data-testid="reset-map-layers">
                                {layers.length
                                    ? intl.formatMessage({ id: 'dataBrowser.resetMapLayers' }, { layers: layers.join(', ') })
                                    : intl.formatMessage({ id: 'dataBrowser.resetMapNoLayers' })}
                            </div>
                        </div>
                    }
                >
                    {this.props.intl.formatMessage({
                        id: defaultMap ? 'dataBrowser.resetMapDescription' : 'dataBrowser.resetSavedMapDescription',
                    })}
                </ConfirmationPopup>
            ),
            name: 'Reset map confirmation',
            title: defaultMap ? 'modals.resetMap' : 'modals.resetSavedMap',
            modalBoxClass: 'modal-box--confirmation',
            canClickAway: true,
            hideCloseButton: true,
        });
    }

    renderAction({ tooltipId, icon, onClick, testId, disabled }) {
        return (
            <Tooltip
                placement="bottom"
                mouseEnterDelay={0.5}
                mouseLeaveDelay={0}
                overlay={this.props.intl.formatMessage({ id: tooltipId })}
            >
                <button
                    className={classNames('map-layers-panel__popup__container__header action-buttons-container action-button', {
                        'disabled-button': disabled,
                    })}
                    onClick={onClick}
                    data-testid={testId}
                    disabled={disabled}
                >
                    <i className="material-icons-outlined"> {icon} </i>
                </button>
            </Tooltip>
        );
    }

    render() {
        const { onClose, onAddLayersClick, onDataUploadClick, intl, isUserStarterTier } = this.props;

        return (
            <div className="map-layers-panel__popup__container__header">
                <span> {intl.formatMessage({id: "dataBrowser.mapLayers"})} </span>
                <div className="map-layers-panel__popup__container__header action-buttons-container">
                    {this.renderAction({
                        tooltipId: isUserStarterTier ? 'starterTier.upgradeToPro' : 'dataBrowser.addLayers',
                        icon: 'local_library',
                        onClick: onAddLayersClick,
                        testId: 'map-layers-add',
                        disabled: isUserStarterTier,
                    })}
                    {this.renderAction({
                        tooltipId: 'dataBrowser.resetMap',
                        icon: 'restart_alt',
                        onClick: this.onResetMapClick,
                        testId: 'map-layers-reset',
                    })}
                    {this.renderAction({
                        tooltipId: isUserStarterTier ? 'starterTier.upgradeToPro' : 'dataBrowser.uploadData',
                        icon: 'cloud_upload',
                        onClick: onDataUploadClick,
                        disabled: isUserStarterTier,
                    })}
                    <div className="map-layers-panel__popup__vertical-divider"/>
                    <Tooltip
                        placement="bottom"
                        mouseEnterDelay={0.5}
                        mouseLeaveDelay={0}
                        overlay={intl.formatMessage({
                            id: 'dataBrowser.minimize',
                        })}
                    >
                        <button
                            className="map-layers-panel__popup__container__header action-buttons-container minimize-button"
                            data-testid="map-layers-close"
                            onClick={onClose}
                        >
                            <i className="material-icons"> keyboard_double_arrow_down </i>
                        </button>
                    </Tooltip>
                </div>
            </div>
        );
    }
}

export default injectIntl(MapLayersPanelHeader);
